export const ArrowDown = () => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M8 5.33331L12 9.33331L4 9.33331L8 5.33331Z" fill="#2B2B2B" />
        </svg>
    )
}

export const ArrowDown2 = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_4_32670)">
                <path d="M12 13.1719L16.95 8.22192L18.364 9.63592L12 15.9999L5.636 9.63592L7.05 8.22192L12 13.1719Z" fill="currentColor" />
            </g>
            <defs>
                <clipPath id="clip0_4_32670">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}